export default __webpack_public_path__ + "static/testimonial-michael-chen-feac124743551f8497371c7a3e96ce83.png";